module.exports = __webpack_public_path__ + "static/media/Banner-Unimed.d2f82ba4.png";